import axios from "libs/axios";
import { UseQueryOptions, useQuery } from "react-query";
import { AxiosError } from "axios";
import { CheckoutDTO } from "features/checkouts-list/type";

interface wageRequest {
  PageNumber?: number;
  PageSize?: number;
  SettlementDataId?: number;
}

const checkoutWagesID = async (data: wageRequest) => {
  return await axios
    .get(`/api/v1/SwitchTransaction/get-with-settlement-data-id`, {
      params: { ...data, version: "1" },
    })
    .then((res) => res.data)
    .catch((err) => err.data);
};

type UseCheckoutWageIDOptions = UseQueryOptions<
  CheckoutDTO,
  AxiosError,
  CheckoutDTO
>;
export const useCheckoutWagesID = (
  data: wageRequest,
  options?: UseCheckoutWageIDOptions
) => {
  return useQuery({
    queryFn: () => checkoutWagesID(data),
    queryKey: [
      "/api/v1/SwitchTransaction/get-with-settlement-data-id",
      data.SettlementDataId,
      data.PageNumber,
    ],
    enabled: !!data.SettlementDataId,
    ...options,
  });
};
